// Bridge to a native Mac/iOS shell (WKWebView script message handler "milk"), for when there is one.
// The shell can also tell the page what it senses — Wi-Fi network, Bluetooth beacons — so the list
// can switch to the store you walked into (see lib/presence.ts).
import { isNative } from './config';

export type NativeMessage =
  | { type: 'ready' }
  | { type: 'sessionChanged'; token: string | null }
  | { type: 'logout' }
  | { type: 'changeServer' }
  /** Start (or stop) reporting Wi-Fi and beacons for these stores. */
  | { type: 'watchPresence'; stores: { id: string; wifiNames: string[]; beacons: string[] }[] }
  | { type: 'passkeyCreate'; requestId: string; options: unknown }
  | { type: 'passkeyGet'; requestId: string; options: unknown };

export function postNative(msg: NativeMessage): boolean {
  if (!isNative) return false;
  try {
    window.webkit?.messageHandlers?.milk?.postMessage(msg);
    return true;
  } catch {
    return false;
  }
}

/** Commands the native shell sends with window.MilkMaybe.handle({...}). */
export type NativeCommand =
  | { type: 'navigate'; path: string }
  | { type: 'presence'; wifiNames?: string[]; beacons?: string[] }
  | { type: 'passkeyResult'; requestId: string; credential?: unknown; error?: string };

const handlers = new Set<(cmd: NativeCommand) => void>();
export function onNativeCommand(fn: (cmd: NativeCommand) => void) {
  handlers.add(fn);
  return () => { handlers.delete(fn); };
}

declare global {
  interface Window {
    MilkMaybe?: {
      handle(cmd: NativeCommand): void;
      version: string;
      /** Sends local changes (and with `pull`, fetches new ones); resolves with the changes still waiting. */
      sync?(timeoutMs?: number, pull?: boolean): Promise<number>;
    };
  }
}

if (typeof window !== 'undefined') {
  window.MilkMaybe = {
    version: '0.1.0',
    handle(cmd: NativeCommand) {
      for (const h of handlers) h(cmd);
    },
  };
}
